import { apiClient } from './apiClient';

export interface CompanyUser {
  id: string;
  companyId: string;
  companyName: string;
  userId: string;
  userEmail: string;
  role: 'ADMIN' | 'EMPLOYEE' | 'VIEWER';
  activated?: boolean;
  activationToken?: string;
}

export interface AddUserToCompanyRequest {
  userEmail: string;
  role: 'ADMIN' | 'EMPLOYEE' | 'VIEWER';
}

export interface UpdateUserRoleRequest {
  role: 'ADMIN' | 'EMPLOYEE' | 'VIEWER';
}

export interface UserSearch {
  id: string;
  email: string;
}

export const companyUserService = {
  // Получить список пользователей компании
  getCompanyUsers: async (companyId: string): Promise<CompanyUser[]> => {
    const response = await apiClient.get(`/companies/${companyId}/users`);
    return response.data;
  },

  // Поиск пользователей по email
  searchUsers: async (companyId: string, email: string): Promise<UserSearch[]> => {
    const response = await apiClient.get(`/companies/${companyId}/users/search-users?email=${encodeURIComponent(email)}`);
    return response.data;
  },

  // Добавить пользователя в компанию
  addUserToCompany: async (companyId: string, data: AddUserToCompanyRequest): Promise<CompanyUser> => {
    const response = await apiClient.post(`/companies/${companyId}/users`, data);
    return response.data;
  },

  // Обновить роль пользователя
  updateUserRole: async (companyId: string, userId: string, data: UpdateUserRoleRequest): Promise<CompanyUser> => {
    const response = await apiClient.put(`/companies/${companyId}/users/${userId}`, data);
    return response.data;
  },

  // Удалить пользователя из компании
  removeUserFromCompany: async (companyId: string, userId: string): Promise<void> => {
    await apiClient.delete(`/companies/${companyId}/users/${userId}`);
  }
};

